<template>
  <div class="mt-5 mb-5">
    <h1 class="title-area">
      <img src="@/assets/images/icons/record-circle-line.png" alt="" />
      {{ title }}
    </h1>
    <div class="mt-5 d-flex">
      <button
        class="btn-detail-area mr-5"
        @click.prevent="$bvModal.show('modal-detail-area')"
        :disabled="loadingDetailArea"
      >
        Detalle del área
        <img src="@/assets/images/icons/eye-line.svg" alt="" />
      </button>
    </div>
    <hr class="hr-filter-info" />
    <div class="mt-5 card-activity">
      <div class="row">
        <div class="col-md-3">
          <ListActivities
            @onSearch="handleSearch"
            @editActivity="editActivity"
            @calification="calification"
            @history="loadhistory"
            :isLoading="isLoading"
            :records="records"
            :risks="risks"
          />
        </div>
        <div class="col-md-9">
          <Calification
            :detailActivity="detailActivity"
            :totalPropios="dataDetailArea?.total"
            :idPosition="idPosition"
            :idArea="idArea"
            :risks="risks"
            @saveDataSuccess="saveDataSuccess"
            @saveDataError="saveDataError"
          />
        </div>
      </div>
    </div>
    <!-- MODAL CREAR ACTIVIDAD -->
    <ModalCreateActivity
      :titleModalActivity="titleModal"
      :record="activity"
      @onSaveActivity="loadActivities"
    />
    <!--  MODAL PROCESO EXITOSO  -->
    <modal-success :messageModal="messageModal" />
    <!-- MODAL PROCESO FALLIDO -->
    <modal-error :error="error" />
    <!-- MODAL HISTORIAL DE ACTIVIDADES -->
    <ModalHistory
      :isLoadingHistory="isLoadingHistory"
      :dataHistory="dataHistory"
      :recordsHistory="recordsHistory"
      @loadPageHistory="loadPageHistory"
    />
    <!-- MODAL DETALLE DE AREA -->
    <ModalDetailArea
      :dataDetailArea="dataDetailArea"
      :title="title"
      :loadingDetailArea="loadingDetailArea"
      @loadRowsPag="loadRowsPag"
    />
  </div>
</template>

<script>
import {
  getAllActivities,
  getHistoryIper,
  debounce,
} from "@/services/health-tracker/matrizIper/service";
import ListActivities from "./ListActivities.vue";
import Calification from "./Calification.vue";
import ModalCreateActivity from "../../modals/ModalCreateActivity.vue";
import ModalSuccess from "../../modals/ModalSuccess.vue";
import ModalError from "../../modals/ModalError.vue";
import ModalHistory from "../../modals/ModalHistory.vue";
import ModalDetailArea from "../../modals/ModalDetailArea.vue";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    idPosition: {
      type: Number,
      default: null,
    },
    idArea: {
      type: Number,
      default: null,
    },
    loadingDetailArea: {
      type: Boolean,
      default: false,
    },
    dataDetailArea: {
      type: Object,
      default: null,
    },
    risks: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    ListActivities,
    Calification,
    ModalCreateActivity,
    ModalSuccess,
    ModalError,
    ModalHistory,
    ModalDetailArea,
  },
  data() {
    return {
      titleModal: "Crear nueva actividad",
      messageModal: "Actividad guardada exitosamente",
      error: {
        message: "Error al crear la actividad, por favor intentelo de nuevo",
      },
      isLoading: true,
      isLoadingHistory: false,
      records: [],
      search: null,
      abortController: null,
      activity: null,
      cualification: null,
      detailActivity: null,
      dataHistory: null,
      recordsHistory: [],
      pageHistory: 1,
    };
  },
  watch: {
    idPosition() {
      const me = this;
      me.loadActivities();
    },
  },
  methods: {
    async loadActivities() {
      const me = this;
      me.isLoading = true;
      me.records = [];
      if (me.abortController) {
        me.abortController.abort(); // Cancela la petición anterior
      }

      me.abortController = new AbortController();
      const signal = me.abortController.signal;
      try {
        const { data } = await getAllActivities(
          me.idPosition,
          {
            search: me.search,
          },
          signal
        );
        me.records = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoading = false;
      }
    },
    handleSearch: debounce(function (search) {
      const me = this;
      me.search = search;
      me.loadActivities();
    }, 300),
    editActivity(record) {
      const me = this;
      me.activity = record;
      me.titleModal = "Editar actividad";
      me.$bvModal.show("modal-create-activity");
    },
    calification(record) {
      const me = this;
      me.detailActivity = record;
    },
    loadRowsPag(page) {
      const me = this;
      me.$emit("loadRowsPag", page);
    },
    saveDataSuccess(value) {
      const me = this;
      me.messageModal = value;
      me.$bvModal.show("modal-success");
    },
    saveDataError(value) {
      const me = this;
      me.error.message = value;
      me.$bvModal.show("modal-fail");
    },
    async loadhistory(id) {
      const me = this;
      me.dataHistory = null;
      me.recordsHistory = [];
      me.$bvModal.show("modal-history-activity");
      me.isLoadingHistory = true;
      try {
        const data = await getHistoryIper(id, {
          page: me.pageHistory,
        });
        console.log(data?.data?.data);
        data?.data?.data.forEach((x) => {
          me.recordsHistory.push({
            Id: x.id,
            Tipo: x.modification_type,
            Fecha: x.date,
            details: x.history,
          })
        });
        me.dataHistory = data;
      } catch (error) {
        console.log(error);
      } finally {
        me.isLoadingHistory = false;
      }
    },
    loadPageHistory(page) {
      const me = this;
      me.pageHistory = page;
      this.loadPageHistory();
    },
  },
  mounted() {
    const me = this;
    me.loadActivities();
  },
};
</script>

<style lang="css" scoped>
.title-area {
  color: "#263238" !important;
  font-size: 21px !important;
  line-height: 24px !important;
}
.btn-detail-area {
  border: 1px solid #5d5fef;
  border-radius: 4px;
  padding: 6px 12px 6px 12px;
  color: #5d5fef;
  font-size: 16px;
  background-color: white;
}
.card-activity {
  border: 1px solid #cfd8dc;
  padding: 24px;
  border-radius: 8px;
}
</style>
